// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","453":"258b012d","667":"35e48c7e","977":"3becd578"}[chunkId] + ".chunk.js";
};